<nav class="navbar navbar-expand fixed-top navbar-light bg-light bg-faded mb-0">

    <!-- Brand -->
    <a class="navbar-brand py-0" [routerLink]="['/']">
        <img class="d-md-none" src="/assets/images/logo-cnr.png" [ngStyle]="{'height': '30px'}">
        <img class="d-none d-md-block" src="/assets/images/logo-cnr-large.png">
        <!--<span class="d-sm-none">xs</span>-->
        <!--<span class="d-md-none">sm</span>-->
        <!--<span class="d-lg-none">md</span>-->
        <!--<span class="d-xl-none">lg</span>-->
        <!--<span>xl</span>-->

    </a>

    <!--&lt;!&ndash; Hamburger &ndash;&gt;-->
    <!--<button class="navbar-toggler navbar-toggler-right" type="button" (click)="toggleNavbar()"-->
            <!--[attr.aria-expanded]="!navbarCollapsed" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">-->
        <!--<span class="navbar-toggler-icon"></span>-->
    <!--</button>-->

    <!-- Navbar content -->
    <div class="navbar-collapse" id="navbarContent" [ngSwitch]="isAuthenticated()">

        <!--Left side-->
        <ul class="navbar-nav mr-auto">
          <div *ngIf="navbarMenu">
            <app-dropdown-navbar *ngFor="let menu of navbarMenu.menus" [active]="menu.isActive()"
                                 [dropdownTitle]="menu.name" [fa]="menu.icon">
                <li *ngFor="let children of menu.getChildren()" [ngClass]="{'dropdown-submenu': !children.isLeaf()}">
                    <!-- Ramo di tipo children-->
                    <a *ngIf="children.isActive() && children.isLeaf()" class="dropdown-item" [routerLink]="[children.path]" >
                        <div class="menuitem_icon"><i class="fa fa-{{ children.icon }}" aria-hidden="true"></i></div>
                        {{ children.label | translate}}
                    </a>
                    <!-- Ramo di tipo menu-->
                    <a *ngIf="children.isActive() && !children.isLeaf()" class="dropdown-item" href="#">
                        <div class="menuitem_icon"><i class="fa fa-{{ children.icon }}" aria-hidden="true"></i></div>
                        {{ children.name | translate}}
                    </a>
                    <ul *ngIf="children.isActive() && !children.isLeaf()" class="dropdown-menu">
                        <li *ngFor="let children2 of children.getChildren()">
                            <a *ngIf="children2.isActive()" 
                                class="dropdown-item"
                                [routerLink]="[children2.path]" >
                                <div class="menuitem_icon"><i class="fa fa-{{ children2.icon }}" aria-hidden="true"></i></div>
                                {{ children2.label | translate}}
                            </a>
                        </li>
                    </ul>
                </li>
            </app-dropdown-navbar>
          </div>

          <i *ngIf="spinner" class="fa fa-spinner fa-spin fa-2x fa-fw" [ngStyle]="{'color': 'white'}"></i>
        </ul>

        <div *ngSwitchCase="false" class="navbar-nav">
            <button class="btn btn-navbar" (click)="OnClickHelp()">
                <i class="fa fa-info-circle pl-2"></i>
                <span jhiTranslate="global.menu.help">Help</span>
            </button>
        </div>

        <!-- Right side -->
        <ul class="navbar-nav">
            <app-dropdown-navbar *ngSwitchCase="true" dropdownTitle="Help" rightAlignment="true" [fa]="'info-circle'">
                <div>
                    <a class="dropdown-item dropdown-item-navbar" href="#" (click)="OnClickHelp()">
                        <span jhiTranslate="global.menu.help">Help</span>
                    </a>    
                </div>
                <div *ngIf="aceUser">
                    <a class="dropdown-item dropdown-item-navbar"
                       [routerLink]="['/configurazione/helpdesk/new']">Apri Segnalazione</a>
                </div>
            </app-dropdown-navbar>

            <app-dropdown-navbar *ngIf="!oidcEnable" dropdownTitle="Account" rightAlignment="true" [user]="user" [fa]="'user'">
                <div *ngSwitchCase="false">
                    <a class="dropdown-item dropdown-item-navbar"
                       #rla="routerLinkActive"
                       [routerLink]="['auth/signin']"
                       routerLinkActive="">
                        Login
                    </a>
                </div>
                <!--
                <div *ngSwitchCase="true">
                    <a class="dropdown-item dropdown-item-navbar"
                       [routerLink]="['/anagrafica/delega']">Deleghe</a>
                </div>
                -->
                <div *ngSwitchCase="true">
                    <a class="dropdown-item dropdown-item-navbar"
                       (click)="onLogout()">Logout</a>
                </div>
            </app-dropdown-navbar>
            <div *ngIf="oidcEnable" class="d-flex flex-row">
                <ngx-cnr-uict-sso-apps-menu 
                    *ngIf="isAuthenticated()" 
                    class="mt-1"
                    [account]="user" 
                    [buttonSize]="'32px'" 
                    [iconSize]="'20px'">
                </ngx-cnr-uict-sso-apps-menu>
                <ngx-cnr-uict-sso-user-menu 
                    *ngIf="isAuthenticated()"
                    [account]="user"
                    (logoutCallback)="onLogout()">
                    <!--
                    <div class="dropdown-divider"></div>
                    <div class="list-group">
                        <a class="dropdown-item dropdown-item-navbar" [routerLink]="['/anagrafica/delega']">Deleghe</a>
                    </div>
                    -->
                </ngx-cnr-uict-sso-user-menu>
            </div>
        </ul>
    </div>

</nav>

<simple-notifications [options]="notificationOptions"></simple-notifications>


<!--[ngStyle]="{'position': 'fixed', 'top':'3.6em', 'z-index': '1000', 'width': '71.2em'}"-->


